// extracted by mini-css-extract-plugin
export var desktop = "Header-module--desktop--0aedd";
export var mobile = "Header-module--mobile--f8a7c";